import { PageContainer } from "@components/PageContainer";
import { BugReportForm } from "@components/BugReportForm";

export function HomePage() {
  return (
    <PageContainer>
      <BugReportForm />
    </PageContainer>
  );
}
